import './app';
import './peripheralsService';

export default '7Terminal.Peripherals';
